import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import CountriesRequest from 'app/requests/Country.requests'

import CountryOverview from './CountryOverview'
import tableConfig from './Country.config'

const Countries = () => {
    const tabs: SidebarTab[] = [{
        url: CommonRoutes.Overview,
        label: 'Overview',
        Component: CountryOverview,
    }]

    const tableControls: TableControlTypes[] = [TableControlTypes.ClearSorting]

    return (
        <SkyNetDomain
            sidebarTabs={tabs}
            name="CountryView"
        >
            <SkyNetTable
                moduleName={CountriesRequest.domainName}
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default Countries
